export const isChargeSuccess = (status?: string) => status === 'succeeded'
